import { useParams } from '../../../../contexts/RouterContext';

/**
 * Hook to determine if the current service is a GitHub App.
 */
const useIsGithubApp = () => {
  const params = useParams<{ service: string }>();
  return params.service === 'github-app';
};

export default useIsGithubApp;
